(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-explode"] && !Shopify.designMode) return;
  try {
    
  class VfExplode extends HTMLElement {
    connectedCallback() {
      this.pin = this.querySelector('.vf-explode__pin');
      this.runway = this.querySelector('.vf-explode__runway');
      if (!this.pin || !this.runway) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.offset = 24;
      this.current = 0;
      this.target = 0;
      this.frame = 0;
      this.onScroll = () => this.request();
      this.onResize = () => {
        this.measure();
        this.request();
      };
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.onResize);
      this.motion.addEventListener('change', this.onResize);
      this.observer = new ResizeObserver(this.onResize);
      this.observer.observe(this.pin);
      this.measure();
      this.current = this.target = this.progress();
      this.render();
    }

    disconnectedCallback() {
      if (!this.motion) return;
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      window.removeEventListener('resize', this.onResize);
      this.motion.removeEventListener('change', this.onResize);
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    measure() {
      if (this.motion.matches) {
        this.pin.style.top = '';
        return;
      }
      const vh = window.innerHeight;
      const h = this.pin.offsetHeight;
      this.offset = h + 32 > vh ? vh - h - 16 : (vh - h) / 2;
      this.pin.style.top = `${Math.round(this.offset)}px`;
    }

    progress() {
      if (this.motion.matches) return 1;
      const top = this.getBoundingClientRect().top;
      const start = this.offset + window.innerHeight * 0.3;
      const end = this.offset - this.runway.offsetHeight * 0.8;
      return Math.min(1, Math.max(0, (start - top) / (start - end)));
    }

    request() {
      this.target = this.progress();
      if (!this.frame) this.frame = requestAnimationFrame(() => this.tick());
    }

    tick() {
      this.frame = 0;
      const diff = this.target - this.current;
      this.current = Math.abs(diff) < 0.002 ? this.target : this.current + diff * 0.18;
      this.render();
      if (this.current !== this.target) this.frame = requestAnimationFrame(() => this.tick());
    }

    render() {
      const p = this.current;
      const seg = (a, b) => {
        const t = Math.min(1, Math.max(0, (p - a) / (b - a)));
        return (t * t * (3 - 2 * t)).toFixed(4);
      };
      this.style.setProperty('--vf-a', seg(0, 0.62));
      this.style.setProperty('--vf-b', seg(0.12, 0.8));
      this.style.setProperty('--vf-c1', seg(0.42, 0.68));
      this.style.setProperty('--vf-c2', seg(0.56, 0.82));
      this.style.setProperty('--vf-c3', seg(0.68, 0.94));
    }
  }

  if (!customElements.get('vf-explode')) customElements.define('vf-explode', VfExplode);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-glass-cards"] && !Shopify.designMode) return;
  try {
    
  class VfGlassCards extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vf-glass__track');
      this.dots = [...this.querySelectorAll('.vf-glass__dots span')];
      this.track.addEventListener('scroll', () => this.mark(), { passive: true });
      this.addEventListener('shopify:block:select', (e) => e.target.scrollIntoView({ block: 'nearest', inline: 'start' }));
      this.mark();
    }

    mark() {
      const cards = [...this.track.children];
      if (!cards.length) return;
      const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      const i = atEnd ? cards.length - 1 : Math.round(this.track.scrollLeft / step);
      this.dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
    }
  }

  if (!customElements.get('vf-glass-cards')) customElements.define('vf-glass-cards', VfGlassCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-home-lineup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vf-lineup-filter')) {
    customElements.define(
      'vf-lineup-filter',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const chip = event.target.closest('button[data-family]');
            if (!chip) return;
            const family = chip.dataset.family;
            this.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b === chip)));
            const grid = this.parentElement.querySelector('[data-lineup]');
            if (!grid) return;
            grid.querySelectorAll('.vf-lu__item').forEach((item) => {
              item.hidden = Boolean(family) && item.dataset.family !== family;
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-journey"] && !Shopify.designMode) return;
  try {
    
  class VfJourney extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout === 'circles') {
        this.cards = this.querySelector('.vf-journey__cards');
        this.dots = [...this.querySelectorAll('.vf-journey__dot')];
        this.cards.addEventListener('scroll', () => this.mark(), { passive: true });
        this.mark();
        this.addEventListener('shopify:block:select', (e) => e.target.scrollIntoView({ block: 'nearest', inline: 'center' }));
        return;
      }
      this.tabs = [...this.querySelectorAll('.vf-journey__tab')];
      this.tabs.forEach((t) => t.addEventListener('click', () => this.show(Number(t.dataset.step))));
      this.querySelector('[role="tablist"]').addEventListener('keydown', (e) => {
        const i = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
        if (e.key === 'ArrowRight') this.show(Math.min(i + 1, this.tabs.length - 1), true);
        if (e.key === 'ArrowLeft') this.show(Math.max(i - 1, 0), true);
      });
      this.addEventListener('shopify:block:select', (e) => {
        if (e.target.dataset.step) this.show(Number(e.target.dataset.step));
      });
    }

    show(i, focus) {
      this.tabs.forEach((t, n) => {
        t.setAttribute('aria-selected', String(n === i));
        t.tabIndex = n === i ? 0 : -1;
      });
      if (focus) this.tabs[i].focus();
      this.querySelectorAll('.vf-journey__frame, .vf-journey__list').forEach((el) => {
        el.hidden = Number(el.dataset.step) !== i;
      });
    }

    mark() {
      const items = [...this.cards.children];
      if (!items.length) return;
      if (this.cards.scrollWidth <= this.cards.clientWidth + 4) {
        this.dots.forEach((d) => d.classList.add('is-done'));
        return;
      }
      const mid = this.cards.scrollLeft + this.cards.clientWidth / 2;
      let active = 0;
      items.forEach((c, n) => {
        if (c.offsetLeft - this.cards.offsetLeft <= mid) active = n;
      });
      this.dots.forEach((d, n) => d.classList.toggle('is-done', n <= active));
    }
  }

  if (!customElements.get('vf-journey')) customElements.define('vf-journey', VfJourney);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class VfStickyAtc extends HTMLElement {
    connectedCallback() {
      this.target = document.querySelector('.product-details buy-buttons-block, .product-details .buy-buttons-block, .product-details form[data-type="add-to-cart-form"]') || document.querySelector('.product-details');
      this.footer = document.querySelector('footer, .shopify-section-group-footer-group');
      if (!this.target) return;
      const io = new IntersectionObserver(() => this.update(), { threshold: [0, 1] });
      io.observe(this.target);
      if (this.footer) io.observe(this.footer);
      window.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();
    }

    update() {
      const r = this.target.getBoundingClientRect();
      const past = r.bottom < 0;
      const atFooter = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
      this.hidden = !past || atFooter;
    }
  }

  if (!customElements.get('vf-sticky-atc')) customElements.define('vf-sticky-atc', VfStickyAtc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-ugc"] && !Shopify.designMode) return;
  try {
    
  class VfUgcVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      const play = this.querySelector('[data-play]');
      const mute = this.querySelector('[data-mute]');
      play.addEventListener('click', () => {
        if (this.video.paused) this.video.play();
        else this.video.pause();
        play.setAttribute('aria-label', this.video.paused ? 'Play' : 'Pause');
      });
      mute.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        mute.setAttribute('aria-label', this.video.muted ? 'Unmute' : 'Mute');
      });
    }
  }

  if (!customElements.get('vf-ugc-video')) customElements.define('vf-ugc-video', VfUgcVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-video-steps"] && !Shopify.designMode) return;
  try {
    
  class VfScrollSteps extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.vf-vsteps__list');
      this.items = [...this.querySelectorAll('.vf-vsteps__item')];
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    update() {
      const line = window.innerHeight * 0.6;
      let lit = 0;
      this.items.forEach((item, i) => {
        const on = item.getBoundingClientRect().top < line;
        item.classList.toggle('is-lit', on || i === 0);
        if (on) lit = i;
      });
      const box = this.list.getBoundingClientRect();
      const fill = Math.max(0, Math.min(1, (line - box.top) / box.height));
      this.list.style.setProperty('--fill', `${fill * 100}%`);
    }
  }

  if (!customElements.get('vf-scroll-steps')) customElements.define('vf-scroll-steps', VfScrollSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-wave-carousel"] && !Shopify.designMode) return;
  try {
    
  class VfWaveCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.vf-waves__slide')];
      this.curves = [...this.querySelectorAll('.vf-waves__curve')];
      this.peak = this.querySelector('.vf-waves__dot--peak');
      this.current = this.querySelector('[data-current]');
      this.buttons = [...this.querySelectorAll('.vf-waves__btn')];
      this.index = 0;
      this.buttons.forEach((b) => b.addEventListener('click', () => this.go(this.index + Number(b.dataset.dir))));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.go(this.index + 1);
        if (e.key === 'ArrowLeft') this.go(this.index - 1);
      });
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.indexOf(e.target);
        if (i > -1) this.go(i);
      });
      this.go(0);
    }

    path(h) {
      const base = 220;
      const top = base - h;
      const edge = base - h * 0.42;
      return `M0 ${edge} C40 ${base - h * 0.12} 55 ${base} 95 ${base} C140 ${base} 158 ${top} 200 ${top} C242 ${top} 260 ${base} 305 ${base} C345 ${base} 360 ${base - h * 0.12} 400 ${edge}`;
    }

    go(i) {
      if (!this.slides.length) return;
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      this.slides.forEach((s, n) => (s.hidden = n !== this.index));
      const h = Number(this.slides[this.index].dataset.height || 60) * 1.9;
      this.curves.forEach((c) => {
        const d = this.path(h * (1 - Number(c.dataset.i) * 0.14));
        c.setAttribute('d', d);
        c.style.d = `path("${d}")`;
      });
      this.peak.style.setProperty('--peak', `${((220 - h) / 240) * 100}%`);
      this.current.textContent = this.index + 1;
      this.buttons[0].disabled = this.index === 0;
      this.buttons[1].disabled = this.index === this.slides.length - 1;
    }
  }

  if (!customElements.get('vf-wave-carousel')) customElements.define('vf-wave-carousel', VfWaveCarousel);

  } catch(e) { console.error(e); }
})();
})();
